import {Box, Stack, Typography} from "@mui/material";
import type {TimeMark} from "../../../../sdo/TimeMark.ts";
import {formatTimeMark} from "../../../../sdo/TimeMark.ts";
import {cardSx, timeLabelSx, titleSx, detailsSx, iconSx} from "./TimelineCardStyles.ts";

export default function TimelineTextCard({mark, icon}: { mark: TimeMark; icon: string }) {
    return (
        <Box sx={cardSx}>
            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                <Box component="img" src={icon} sx={iconSx} />
                <Stack spacing={0.3} sx={{minWidth: 0}}>
                    <Typography sx={timeLabelSx}>{formatTimeMark(mark)}</Typography>
                    <Typography sx={titleSx}>{mark.title}</Typography>
                    {mark.details && (
                        <Typography sx={detailsSx}>{mark.details}</Typography>
                    )}
                </Stack>
            </Stack>
        </Box>
    );
}
